module.exports = __webpack_public_path__ + "img/i2.c2a14efa.jpg";